import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, NumberTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { Charge, ChargeEditInput, ChargeEditResult } from '../charges/charges.component';
import { EditChargeDialogComponent } from '../charges/edit-charge-dialog/edit-charge-dialog.component';
import { CorrectAmountDialogComponent } from './correct-amount-dialog/correct-amount-dialog.component';
import { CorrectOrderDialogComponent } from './correct-order-dialog/correct-order-dialog.component';
import { ReturnDeliveryDialogComponent } from './return-delivery-dialog/return-delivery-dialog.component';
import { Umbuchung } from './umbuchung';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'kiene-goods-receipt-history',
    templateUrl: './goods-receipt-history.component.html',
    styleUrls: ['./goods-receipt-history.component.scss'],
})
export class GoodsReceiptHistoryComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Wareneingangshistorie';
        this.tableDescriptor.uniqueIdentifier = 'Wareneingangshistorie';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'wareneingang/';

        this.tableDescriptor.searchPlaceholder = 'Wareneingangshistorie durchsuchen';
        this.tableDescriptor.columns.push(new TableColumn('lagerplatz', 'Lagerplatz Ziel'));
        this.tableDescriptor.columns.push(new TableColumn('artikel_me', 'Artikel'));
        this.tableDescriptor.columns.push(new TableColumn('lieferant', 'Lieferant'));
        this.tableDescriptor.columns.push(new TableColumn('bestell_nr', 'Bestellung'));
        this.tableDescriptor.columns.push(new TableColumn('charge', 'Charge'));
        this.tableDescriptor.columns.push(new TableColumn('menge', 'Menge', 'number'));
        this.tableDescriptor.columns.push(new TableColumn('mhd', 'MHD', 'date'));
        if (this.localStorageService.currentUserIsAdmin()) {
            this.tableDescriptor.columns.push(new NumberTableColumn('einzelpreis', 'Einzelpreis', '1.2-2', 'EUR'));
        }
        this.tableDescriptor.columns.push(new TableColumn('lagerplatz_quelle', 'Lagerplatz Quelle'));
        this.tableDescriptor.columns.push(
            new KieneBooleanTableColumn('ruecklieferung_vorhanden', 'Rücklieferung vorhanden'),
        );
        this.tableDescriptor.columns.push(new TableColumn('erstellt', 'Eingang', 'datetime'));

        this.tableDescriptor.permissionView = 1651;

        this.tableDescriptor.options.push(
            new TableOption(this.openCorrectAmountDialog.bind(this), 'Menge korrigieren', 'edit', 1653),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openEditChargeDialog.bind(this), 'Charge bearbeiten', 'edit', 1042),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openCorrectOrderDialog.bind(this), 'Bestell Nr. korrigieren', 'edit', 1653),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openReturnDeliveryDialog.bind(this), 'Rücklieferung', 'assignment_return', 1653),
        );

        this.tableDescriptor.initialSortColumn = 'erstellt';
        this.tableDescriptor.initialSortDirection = 'desc';
    }

    openCorrectAmountDialog(grh: GoodsReceiptHistory) {
        const dialogRef = this.dialog.open(CorrectAmountDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { grh: grh },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.tableService.reload();
            }
        });
    }

    openCorrectOrderDialog(grh: GoodsReceiptHistory) {
        const dialogRef = this.dialog.open(CorrectOrderDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { grh: grh },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.tableService.reload();
            }
        });
    }

    private openReturnDeliveryDialog(value: Umbuchung) {
        const dialogRef = this.dialog.open(ReturnDeliveryDialogComponent, { data: value });
        dialogRef.afterClosed().subscribe(() => {
            this.tableService.reload();
        });
    }

    private openEditChargeDialog(charge: Charge): void {
        const input = new ChargeEditInput();
        input.charge = charge;

        this.dialog
            .open(EditChargeDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: ChargeEditResult) => {
                    if (result?.confirm) {
                        this.tableService.updateEntity(this.apiBaseUrl + 'charge/update.php', result.charge).subscribe({
                            next: () => {
                                this.tableService.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage('Die Charge konnte nicht geändert werden!', err);
                            },
                        });
                    }
                },
            });
    }
}

export class GoodsReceiptHistory {
    lagerplatz: string;
    artikel: string;
    artikel_me: string;
    bestell_nr: string;
    bestellung_extern_id: number;
    charge: string;
    mhd: Date;
    menge: number;
    erstellt: Date;
    umbuchung_id: number;
}
